/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetupParameterKindListViewModel } from '../../models/setup-parameter-kind-list-view-model';

export interface GetSetupParameterKindByExternalId$Params {
  externalSetupParameterKindId: string;
}

export function getSetupParameterKindByExternalId(http: HttpClient, rootUrl: string, params: GetSetupParameterKindByExternalId$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameterKindListViewModel>> {
  const rb = new RequestBuilder(rootUrl, getSetupParameterKindByExternalId.PATH, 'get');
  if (params) {
    rb.path('externalSetupParameterKindId', params.externalSetupParameterKindId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetupParameterKindListViewModel>;
    })
  );
}

getSetupParameterKindByExternalId.PATH = '/api/v1/SetupParameter/GetSetupParameterKindByExternalId/{externalSetupParameterKindId}';
